import './AddAdminRow.scss'
import React from 'react'
import { connect } from 'react-redux'

import OpTextbox from 'common/views/components/OpTextbox'
import OpSelect from 'common/views/components/OpSelect'

import { editAdminInvite, validateAdminEmail, validateAdminName } from 'broker/redux/manage_users'
import { BROKER_CONTACT_TYPES } from 'common/constants'


const AddAdminRow = ({ invite, dispatch }) => {
  const { email, name, phone, role, emailErrorMessage, nameErrorMessage, roleErrorMessage, key } = invite
  return (
    <div className="AddAdminRow">
      <div className="admin-email">
          <OpTextbox
            label="Email"
            iconClass="fa fa-envelope"
            value={email}
            errorMsg={emailErrorMessage}
            onBlur={() => dispatch(validateAdminEmail({ key }))}
            onChange={e => dispatch(editAdminInvite({ key, email: e.target.value }))}
            required
          />
        </div>

      <div className="admin-name">
        <OpTextbox
          label="Name"
          iconClass="fa fa-user-circle"
          value={name}
          errorMsg={nameErrorMessage}
          onBlur={() => dispatch(validateAdminName({ key }))}
          onChange={e => dispatch(editAdminInvite({ key, name: e.target.value }))}
          required
        />
      </div>

      <div className="admin-role">
        <OpSelect
          label="Role"
          placeholder="Select..."
          clearable={false}
          searchable={false}
          backspaceRemoves={false}
          value={role}
          errorMsg={roleErrorMessage}
          onChange={option => dispatch(editAdminInvite({ key, role: option.value }))}
          options={BROKER_CONTACT_TYPES}
          required
        />
      </div>

      <div className="admin-phone">
        <OpTextbox
          label="Phone Number"
          value={phone}
          onChange={e => dispatch(editAdminInvite({ key, phone: e.target.value }))}
        />
      </div>

    </div>
  )
}

const mapStateToProps = () => ({})
const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(AddAdminRow)
